"use client";

import React, { useEffect, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "01",
  title: "Inscripción",
  description: "Evaluamos tu nivel para que aproveches las clases desde el primer día"
}, {
  number: "02",
  title: "Aprendizaje",
  description: "\"Tu nivel, tu grupo, tu éxito\". Esa es nuestra manera de trabajar. Participarás en un grupo reducido de alumnos para que te resulte sencillo el aprendizaje."
}, {
  number: "03",
  title: "Resultados\xA0",
  description: "Superarás las asignaturas que más te cuestan con nuestro respaldo diario.."
}];
export default function TheJourneyToMagic() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll();
  const {
    ref: stepsRef,
    isVisible: stepsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: progressRef,
    isVisible: progressVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const [progressValue, setProgressValue] = useState(0);
  useEffect(() => {
    if (progressVisible) {
      const timer = setTimeout(() => setProgressValue(100), 400);
      return () => clearTimeout(timer);
    }
  }, [progressVisible]);
  return <section data-section-id="223509" id="ruta-de-aprendizaje" className="dark py-24 lg:py-32 bg-background text-foreground overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {}
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tight">
            Ruta de Aprendizaje
          </h2>
          <div className="w-16 h-[1px] bg-primary mx-auto mb-6"></div>
          <p className="text-lg text-muted-foreground font-default tracking-wide">
            Un proceso educativo estructurado y eficiente, diseñado para transformar tu carrera con claridad y autoridad.
          </p>
        </div>

        {}
        <div ref={stepsRef} className="relative mt-16">
          {}
          <div className="hidden md:block absolute top-[4.5rem] left-[10%] right-[10%] h-[2px] border-t-2 border-dotted border-primary/20 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8">
            {steps.map((step, i) => <div key={i} data-index={i} className={`relative transition-all duration-1000 ease-out ${stepsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                <span className="absolute -top-12 -left-4 text-[80px] leading-none font-default font-bold text-primary/20 select-none z-0">
                  {step.number}
                </span>

                {}
                <div className="relative z-10 pt-8 px-2">
                  <Badge variant="secondary" className="mb-6 bg-primary/10 text-primary hover:bg-primary/20 border-none shadow-none px-3 py-1 text-xs font-mono tracking-widest uppercase">
                    Fase {step.number}
                  </Badge>
                  <h3 className="text-xl font-default font-bold text-foreground mb-4 tracking-tight">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground font-default leading-relaxed text-sm md:text-base tracking-normal">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {}
        <div ref={progressRef} className={`mt-24 max-w-3xl mx-auto px-4 transition-opacity duration-1000 ${progressVisible ? "opacity-100" : "opacity-0"}`}>
          <p className="text-center text-muted-foreground mb-4 uppercase tracking-widest !text-2xl !font-sans !font-extrabold">
            Tu evolución profesional comienza aquí
          </p>
          <Progress value={progressValue} className="h-1 bg-muted" />
        </div>

      </div>
    </section>;
}